import { useEffect } from "react";

const SITE = "Cloud Beaker Corporation";
const ORIGIN =
  (typeof window !== "undefined" && window.location.origin) ||
  "https://cloud-beaker-prod.preview.emergentagent.com";

function upsertMeta(attr, key, content) {
  if (!content) return;
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function upsertLink(rel, href) {
  let el = document.head.querySelector(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", rel);
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
}

function upsertJsonLd(id, data) {
  let el = document.getElementById(id);
  if (!el) {
    el = document.createElement("script");
    el.type = "application/ld+json";
    el.id = id;
    document.head.appendChild(el);
  }
  el.textContent = JSON.stringify(data);
}

/**
 * SEO manager (CRA-compatible, no external dep).
 * Sets title, description, canonical, OpenGraph, Twitter cards and JSON-LD.
 */
export default function Seo({
  title,
  description,
  path = "/",
  type = "website",
  jsonLd = null,
}) {
  useEffect(() => {
    const fullTitle = title ? `${title} | ${SITE}` : SITE;
    document.title = fullTitle;
    const url = `${ORIGIN}${path}`;

    upsertMeta("name", "description", description);
    upsertLink("canonical", url);

    upsertMeta("property", "og:site_name", SITE);
    upsertMeta("property", "og:title", fullTitle);
    upsertMeta("property", "og:description", description);
    upsertMeta("property", "og:type", type);
    upsertMeta("property", "og:url", url);

    upsertMeta("name", "twitter:card", "summary_large_image");
    upsertMeta("name", "twitter:title", fullTitle);
    upsertMeta("name", "twitter:description", description);

    if (jsonLd) {
      upsertJsonLd("cb-jsonld-page", jsonLd);
    }
  }, [title, description, path, type, jsonLd]);

  return null;
}

export const ORGANIZATION_JSONLD = {
  "@context": "https://schema.org",
  "@type": "ProfessionalService",
  name: "Cloud Beaker Corporation",
  description:
    "Multi-cloud transformation partner delivering strategy, engineering, security and managed services across Google Cloud, Microsoft Azure and Alibaba Cloud.",
  url: ORIGIN,
  areaServed: "Global",
  serviceType: [
    "Cloud Strategy",
    "Cloud Migration",
    "Application Modernization",
    "Managed Cloud Services",
    "Cloud Security",
    "AI and Data",
  ],
};
